
import axios from '../plugins/axiosPlugins'
import runEvn from '../modular/runEvn/RunEvn'
const baseURL = runEvn().apiBaseUrl;

/**
 * 获取物资信息
 * @returns 
 */
 export const getDetail = (id:string): any  => {
    return axios.get(`${baseURL}/Supplies/${id}`)
}

/**
 * 发布捐赠物资信息
 * @returns 
 */
 export const publicSupplies = (obj:any): any  => {
    return axios.post(`${baseURL}/Supplies`,obj)
}

/**
 * 删除
 * @returns 
 */
 export const Delete = (id:string): any  => {
    return axios.delete(`${baseURL}/Supplies/${id}`,)
}
 
/**
 * 更新
 * @returns 
 */
 export const Update = (obj:any): any  => {
    return axios.put(`${baseURL}/Supplies`,obj)
}
 